import moment from "moment";
import React, { useState } from "react";
import Swal from "sweetalert2";

const ModalFormVencimientoDoc = ({docToEdit,index,actualizarFecVencimientoDoc,actualizarDocs,minimizar}) => {

    const [fecha,setFecha] = useState(docToEdit ? moment.utc(docToEdit.fecha).format('YYYY-MM-DD') : '');

    const handleUpdateFecVencimiento = async() => {
        const res = await actualizarFecVencimientoDoc(docToEdit.activoID,docToEdit.documentoID,fecha);
        if(res.actualizado){ 
            actualizarDocs();
            minimizar();
            Swal.fire({
                title: `Actualizacion realizada!`,
                icon: 'success',
                text: `La fecha de vencimiento para el documento ${docToEdit.nameDocumento} se actualizo correctamente!`,//${resp.tDocNroFor}
                showConfirmButton: true,
                allowEnterKey: true
            });
        }else{
            Swal.fire({
                title: `Algo no funciono segun lo esperado!`,
                icon: 'success',
                text: `No se logro actualizar la fecha de vencimiento para el documento ${docToEdit.nameDocumento}!`,
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    return <div className="modalFormDiv modalFormFVecDoc">
    <button className="minimizarBtn" onClick={minimizar}>X</button>
    <div className="headerModalForm">Actualizar fecha vencimiento</div>
    <div className="bodyModalForm">
        <h6>Fecha de Vencimiento</h6>
        <div className="inputGroup">
            <label>Fecha de Vencimiento</label>
            <input type="date" value={fecha} onChange={(e)=>setFecha(e.target.value)}/>
        </div>
        <div className="buttonsModalDiv">
            <button className="modalFormBtn" id="updFServBtn" onClick={()=>handleUpdateFecVencimiento()}>Sí</button>    
            <button className="modalFormBtn" id="cancelBtn" onClick={minimizar}>No, Cancelar</button>    
        </div>
    </div>
</div>

}

export default ModalFormVencimientoDoc;